export function currentUrlWithParam(key: string, value: string): string {
  const url = new URL(window.location.href)
  url.searchParams.set(key, value)
  return `${url.pathname}${url.search}`
}
